import { Pipe, PipeTransform } from '@angular/core';
import { AlertTriangle, CheckCircle2, Circle, Info, LucideIconData, TrendingUp, XCircle } from 'lucide-angular';

/** Supported visual color variants for small badge UI elements. */
export type BadgeVariant = 'green' | 'blue' | 'amber' | 'red' | 'purple' | 'gray';

/**
 * Maps a badge color variant to the Tailwind classes used by stat/info badges.
 */
@Pipe({ name: 'variantBadge', standalone: true })
export class VariantBadgePipe implements PipeTransform {
  /**
   * Returns the badge background and text color classes for a variant.
   *
   * @param variant Semantic color variant requested by the template.
   * @returns Tailwind class string for the badge.
   */
  transform(variant: BadgeVariant): string {
    switch (variant) {
      case 'green':  return 'bg-talos-ink/7 text-talos-ink';
      case 'blue':   return 'bg-talos-ink/7 text-talos-ink';
      case 'amber':  return 'bg-talos-ink/7 text-talos-ink';
      case 'red':    return 'bg-talos-ink/7 text-talos-ink';
      case 'purple': return 'bg-talos-ink/7 text-talos-ink';
      default:       return 'bg-talos-ink/7 text-talos-ink';
    }
  }
}

/**
 * Maps a badge color variant to its badge icon.
 */
@Pipe({ name: 'variantBadgeIcon', standalone: true })
export class VariantBadgeIconPipe implements PipeTransform {
  /**
   * Returns the Lucide icon for a semantic color variant.
   *
   * @param variant Semantic color variant requested by the template.
   */
  transform(variant: BadgeVariant): LucideIconData {
    switch (variant) {
      case 'green':  return TrendingUp;
      case 'blue':   return Info;
      case 'amber':  return AlertTriangle;
      case 'red':    return XCircle;
      case 'purple': return CheckCircle2;
      default:       return Circle;
    }
  }
}
